/* eslint-disable max-len */

import React from 'react';
import type { SVGProps } from 'react';

export interface BookProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

export const Book: React.FC<BookProps> = ({ color = '#171717', ...props }) => {
  return (
    <svg width={20} height={21} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M2.91675 15.2113V6.04464C2.91675 2.71131 3.75008 1.87798 7.08341 1.87798H12.9167C16.2501 1.87798 17.0834 2.71131 17.0834 6.04464V14.378C17.0834 14.4946 17.0834 14.6113 17.0751 14.728"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.29175 12.7113H17.0834V15.628C17.0834 17.2363 15.7751 18.5446 14.1667 18.5446H5.83341C4.22508 18.5446 2.91675 17.2363 2.91675 15.628V15.0863C2.91675 13.778 3.98341 12.7113 5.29175 12.7113Z"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66675 6.04463H13.3334"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M6.66675 8.9613H10.8334" stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
